import { Component } from "react";
import { Provider } from "react-redux";

import store from "store/store";

import SvgRoot from "./SvgRoot";
import ViewerFacade from "../ViewerFacade";

interface SvgOverlayProps {
  viewerFacade: ViewerFacade;
}

class SvgOverlay extends Component<SvgOverlayProps> {
  render() {
    return (
      <Provider store={store}>
        <SvgRoot viewerFacade={this.props.viewerFacade} />
      </Provider>
    );
  }
}

// @ts-ignore  Webstorm bug: it thinks there's more than one default export in this file
export default SvgOverlay;
